var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 28V32.3333C25.8333 32.908 25.6051 33.4591 25.1987 33.8654C24.7924 34.2717 24.2413 34.5 23.6667 34.5H8.5L2 41V19.3333C2 18.7587 2.22827 18.2076 2.6346 17.8013C3.04093 17.3949 3.59203 17.1667 4.16667 17.1667H8.5M41 25.8333L34.5 19.3333H19.3333C18.7587 19.3333 18.2076 19.1051 17.8013 18.6987C17.3949 18.2924 17.1667 17.7413 17.1667 17.1667V4.16667C17.1667 3.59203 17.3949 3.04093 17.8013 2.6346C18.2076 2.22827 18.7587 2 19.3333 2H38.8333C39.408 2 39.9591 2.22827 40.3654 2.6346C40.7717 3.04093 41 3.59203 41 4.16667V25.8333Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.99d9d308a68d79938d3ebc04d9266e90.svg";
export { ForwardRef as ReactComponent };